module.exports = __webpack_public_path__ + "img/illustration_1.a05ba458.svg";